var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"canvas_side",staticClass:"canvas_side"},[_c('canvas',{ref:"canvas",attrs:{"id":_vm.id},on:{"mousedown":_vm.onCanvasMouseDown,"mouseup":_vm.onCanvasMouseUp,"mousemove":_vm.onCanvasMouseMove,"mouseout":_vm.onCanvasMouseOut}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24c2c128","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cv.vue
// module id = null
// module chunks = 